// extracted by mini-css-extract-plugin
module.exports = {"container":"_0a2917c"};